/**
 * The one `ilike:` filter per column that a CRM roster search term becomes.
 * The API ANDs its filters, so each is a separate request, merged by user
 * afterwards.
 *
 * Names are matched token by token, joined with `%`: "julie musæus" has to
 * find "Julie Lousie Musæus", which a single `%julie musæus%` never does. The
 * view keeps `full_name` and `full_name_rev`, so the tokens may be typed
 * given-name-first or family-name-first.
 *
 * The e-mail term is matched whole, so "@amino.no" — or a bare "amino.no" —
 * finds every address in the domain. A term with a space is not an address,
 * so it skips that column rather than scan the view for a certain miss.
 */
export function crmSearchFilters(term: string): Array<[string, string]> {
  const tokens = term.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return [];
  const name = `ilike:%${tokens.join("%")}%`;
  const filters: Array<[string, string]> = [
    ["filter[fullName]", name],
    ["filter[fullNameRev]", name],
  ];
  if (tokens.length === 1)
    filters.push(["filter[email]", `ilike:%${tokens[0]}%`]);
  return filters;
}
